import {
  CLEAR_USER_BY_ID,
  GET_USER_BY_ID,
  GET_USER_BY_ID_FAIL,
  GET_USER_BY_ID_SUCCESS,
} from '../constants/resetPasswordConstants';

const initialState = {
  loading: false,
  result: null,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_BY_ID:
      return {
        ...state,
        loading: true,
        result: null,
        error: null,
      };
    case GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data,
      };
    case GET_USER_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CLEAR_USER_BY_ID:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
